import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  fleetData: null,
}

let connectivityDataByAirlinesCall = null
let maintIssueDataByAirlinesCall = null
let fdeDataByAirlinesSummaryCall = null
let fdeDetailDataCall = null
let healthScoreByTailDataCall = null
let healthScoreByFeatureDataCall = null
let healthScoreTrendDataCall = null
let healthScorePhmAlertDataCall = null
let healthScoreMxRecOverlaysDataCall = null

const getters = {
  connectivityData(airlineIds) {
    if (connectivityDataByAirlinesCall) {
      connectivityDataByAirlinesCall.cancel(
        'Only one group request allowed at a time.',
      )
    }

    let airlineList = ''
    airlineIds.forEach(id => {
      airlineList += `&airlineIds=${id}`
    })

    connectivityDataByAirlinesCall = axios.CancelToken.source()
    return axios.get(`/NewDataFiles/Summary?&daysBack=-3${airlineList}`, {
      cancelToken: connectivityDataByAirlinesCall.token,
    })
  },

  maintenanceIssuesData(params) {
    if (maintIssueDataByAirlinesCall) {
      maintIssueDataByAirlinesCall.cancel(
        'Only one group request allowed at a time.',
      )
    }

    const url = '/MaintenanceIssue'
    const URLParams = new URLSearchParams()

    // Airlines
    params.airlineNames?.forEach(name => {
      URLParams.append('airlines', name)
    })

    // Statuses
    params.statuses?.forEach(status => {
      URLParams.append('statuses', status.id)
    })

    maintIssueDataByAirlinesCall = axios.CancelToken.source()
    return axios.get(url, {
      params: URLParams,
      cancelToken: maintIssueDataByAirlinesCall.token,
    })
  },

  flightDeckEffectSummaryData(airlineIds) {
    if (fdeDataByAirlinesSummaryCall) {
      fdeDataByAirlinesSummaryCall.cancel(
        'Only one group request allowed at a time.',
      )
    }
    let airlineList = ''
    airlineIds.forEach(id => {
      airlineList += `&airlineIds=${id}`
    })
    fdeDataByAirlinesSummaryCall = axios.CancelToken.source()
    return axios.get(`/Dplf/SummaryAllData?${airlineList}`, {
      cancelToken: fdeDataByAirlinesSummaryCall.token,
    })
  },

  flightDeckEffectDetailData({flightNumber, tailNumber}) {
    if (fdeDetailDataCall) {
      fdeDetailDataCall.cancel('Only one group request allowed at a time.')
    }

    fdeDetailDataCall = axios.CancelToken.source()
    return axios.get(`/Dplf?flight=${flightNumber}&tailNumber=${tailNumber}`, {
      cancelToken: fdeDetailDataCall.token,
    })
  },

  healthScoreByTailData(options) {
    if (healthScoreByTailDataCall) {
      healthScoreByTailDataCall.cancel(
        'Only one group request allowed at a time.',
      )
    }

    let airlineList = ''
    options.airlineIds.forEach((id, index) => {
      airlineList += index > 0 ? `&airlineIds=${id}` : `airlineIds=${id}`
    })

    let featureList = ''
    options.featureIds.forEach(id => {
      featureList += `&rs=${id}`
    })

    healthScoreByTailDataCall = axios.CancelToken.source()
    return axios.get(`/Feature/RiskScoreSummary?${airlineList}${featureList}`, {
      cancelToken: healthScoreByTailDataCall.token,
    })
  },

  healthScoreByFeatureData(options) {
    if (healthScoreByFeatureDataCall) {
      healthScoreByFeatureDataCall.cancel(
        'Only one group request allowed at a time.',
      )
    }

    const tailNumber = options.tailNumber || ''

    let featureList = ''
    options.featureIds.forEach(id => {
      featureList += `&rs=${id}`
    })

    healthScoreByFeatureDataCall = axios.CancelToken.source()
    return axios.get(
      `/Feature/RiskScore?tailNumber=${tailNumber}${featureList}`,
      {
        cancelToken: healthScoreByFeatureDataCall.token,
      },
    )
  },

  healthScoreTrendData(options) {
    if (healthScoreTrendDataCall) {
      healthScoreTrendDataCall.cancel(
        'Only one group request allowed at a time.',
      )
    }

    const featureId = options.featureId || 0
    const tailNumber = options.tailNumber || ''
    const isRiskScore = options.isRiskScore || false
    healthScoreTrendDataCall = axios.CancelToken.source()
    return axios.get(
      `/Feature/${featureId}/Data?tailNumber=${tailNumber}&isRiskScore=${isRiskScore}`,
      {
        cancelToken: healthScoreTrendDataCall.token,
      },
    )
  },

  healthScorePhmAlertData(options) {
    if (healthScorePhmAlertDataCall) {
      healthScorePhmAlertDataCall.cancel(
        'Only one group request allowed at a time.',
      )
    }

    const riskscoreId = options.featureId || 0
    const aircraftId = options.aircraftId || ''
    healthScorePhmAlertDataCall = axios.CancelToken.source()
    return axios.get(
      `/MaintenanceAlert?aircraftId=${aircraftId}&riskscoreId=${riskscoreId}`,
      {
        cancelToken: healthScorePhmAlertDataCall.token,
      },
    )
  },

  healthScoreMxRecOverlaysData() {
    if (healthScoreMxRecOverlaysDataCall) {
      healthScoreMxRecOverlaysDataCall.cancel(
        'Only one group request allowed at a time.',
      )
    }

    healthScoreMxRecOverlaysDataCall = axios.CancelToken.source()
    return axios.get(`/MaintenanceIssue?aircraftId=13`, {
      cancelToken: healthScoreMxRecOverlaysDataCall.token,
    })
  },
}

const saves = {}

export default class FleetService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
